export default __webpack_public_path__ + "static/media/home-banner-mobile-ke.07b99957.webp";